<footer class="h-[50px] bg-[#333] text-white flex items-center justify-center shrink-0 w-full text-[0.85rem]">
  <div class="flex items-center justify-between w-full px-6 max-w-[1400px]">
    <div class="flex items-center">
      <span class="opacity-80">
        © {{ currentYear }} Students and Lecturers Portal. {{ ts.t('footer_rights') }}
      </span>
    </div>

    <div class="flex items-center">
      @if (versionLoading()) {
        <span class="text-gray-400">Loading version...</span>
      } @else if (versionError()) {
        <span class="text-red-400" [title]="versionError()"> Version Error </span>
      } @else if (versionDisplayName()) {
        <a [href]="versionFileUrl()" (click)="onOpenReleaseNotes($event)" class="text-blue-300 hover:text-blue-200 hover:underline transition-all cursor-pointer" target="_blank" rel="noopener noreferrer"
          [title]="'Click to open release notes'">
          <span>Version {{ versionDisplayName() }}</span>
        </a>
      } @else {
        <span class="text-gray-400">No version</span>
      }
    </div>

    <div class="flex items-center gap-4">
      <span class="cursor-pointer opacity-80 hover:opacity-100 truncate max-w-[100px] md:max-w-none">{{ ts.t('footer_privacy') }}</span>
      <span class="opacity-30">|</span>
      <span class="cursor-pointer opacity-80 hover:opacity-100 truncate max-w-[100px] md:max-w-none">{{ ts.t('footer_terms') }}</span>
      <span class="opacity-30">|</span>
      <span class="cursor-pointer opacity-80 hover:opacity-100 truncate max-w-[100px] md:max-w-none">{{ ts.t('footer_contact') }}</span>
    </div>
  </div>
</footer>